import React from "react";
import Text from "@atlas/uicorn/lib/Display/Text";
import styles from "../../styles/layout-header.standard.module.css";
import { AppSettings } from "../../lib/get-app-settings";

export default function StandardLayoutHeader(
  props: TStandardLayoutHeaderProps
) {
  const { appSettings } = props;

  return (
    <div className={styles.header}>
      <Text h="1">{appSettings.supportPortalTitle}</Text>
      <Text>{appSettings.supportPortalDescription}</Text>
    </div>
  );
}

type TStandardLayoutHeaderProps = {
  appSettings: AppSettings;
};
